import './twitter_content_view.js.coffee'
Monitoring.Views.SocialContents ||= {}

class Monitoring.Views.SocialContents.TwitterDirectMessageContentView extends Monitoring.Views.SocialContents.TwitterContentView
